import React from "react";

const NewBadge = ({ className = "" }) => (
    <span
        className={`flex-shrink-0 bg-red-600 text-white px-2 py-0.5 rounded-full font-semibold tracking-wide ${className}`.trim()}
        style={{ fontSize: "12px" }}
    >
        New
    </span>
);

export default NewBadge;
